import styled, { css } from 'styled-components';
import setBreakpointStyle from '~utils/styledComponentsHelpers/setBreakpointStyle';
import { GreenButton } from '~quiz/components/styledComponents/buttons';

export const Form = styled.form<{ columnBreakpoint: string }>`
  display: flex;
  flex-direction: column;
  margin-top: 19px;

  ${({ columnBreakpoint }) =>
    setBreakpointStyle(
      columnBreakpoint,
      css`
        flex-direction: row;
      `,
    )}
`;

export const InputWrapper = styled.div<{ columnBreakpoint: string }>`
  min-width: 225px;
  margin-bottom: 20px;

  ${({ columnBreakpoint }) =>
    setBreakpointStyle(
      columnBreakpoint,
      css`
        margin-bottom: 0;

        &:not(:last-child) {
          margin-right: 20px;
        }
      `,
    )}
`;

export const SubmitButton = styled(GreenButton)<{ columnBreakpoint: string }>`
  width: 100%;
  font-size: 15px;
  line-height: 15px;
  padding: 0 57px;

  ${({ columnBreakpoint }) =>
    setBreakpointStyle(
      columnBreakpoint,
      css`
        margin-left: 20px;
        max-width: auto;
      `,
    )}
`;

export const SubmitSuccessMessage = styled.div`
  text-align: center;
`;

export const WomanDiv = styled.div`
  width: 127px;
  height: 127px;
  margin-right: 40px;
  @media (max-width: 660px) {
    margin-right: 20px;
  }
  @media (max-width: 660px) {
    display: none;
  }
`;
